
import { Component, OnInit, NgZone, ChangeDetectorRef, HostListener } from '@angular/core';
import { IAppConfig } from 'src/config/app-config.model';
import { AppConfig } from 'src/config/app-config.service';
import { Language } from 'src/core/utility/enums/enums';

@Component({
  selector: 'adahi-header',
  templateUrl: './header.component.html'
})
export class HeaderComponent implements OnInit {
  mobileView: boolean = false;
  appSettings: IAppConfig;
  twitterUrl:string;
  facebookUrl:string;
  youtubeUrl:string;
  trackOrderUrl:string;
  signUrl:string;
  isLoggedIn: boolean = false;
  constructor(private ngZone: NgZone) {
    this.appSettings = AppConfig.settings;
    this.twitterUrl = this.appSettings.twitterUrl;
    this.facebookUrl = this.appSettings.facebookUrl;
    this.youtubeUrl = this.appSettings.youtubeUrl;
    this.trackOrderUrl = "/"+Language[_spPageContextInfo.currentLanguage]+this.appSettings.trackOrderUrl;
    this.signUrl="/"+Language[_spPageContextInfo.currentLanguage]+this.appSettings.signUrl;
    if (_spPageContextInfo.userId != 0) {
      this.isLoggedIn = true;
    } else {
      this.isLoggedIn = false;
      localStorage.setItem('rep', '0');
    }
   }

   @HostListener('window:resize')
   onResize() {

    if (window.innerWidth < 1200) {
      
      if(!this.mobileView){
        this.ngZone.run(() => {
          this.mobileView = true;
        });
      }

    } else {

      if(this.mobileView){
        this.ngZone.run(() => {
          this.mobileView = false;
        });
      }
    }





   }

  ngOnInit() {
    if (window.innerWidth < 1200) {
      
      if(!this.mobileView){
        this.ngZone.run(() => {
          this.mobileView = true;
        });
      }

    } else {

      if(this.mobileView){
        this.ngZone.run(() => {
          this.mobileView = false;
        });
      }
    }
  }

}
